import React, { FC } from 'react';
import { useParams } from 'react-router-dom';

import { ContentLoadError, PageTitle, PageWrapper, Spinner } from '../../../components';
import { useWarmup } from '../../../hooks';
import { useGetOrganization, useQueryHelper } from '../../../queries';
import { CreateOrganizationWizard } from '../components';

export const EditOrganization: FC = () => {
  const { id } = useParams();
  useWarmup(['v3-getOrganization', 'v3-updateOrganization', 'v3-checkDomainAvailability']);

  const organizationQuery = useGetOrganization(id);
  const { data, refetch } = organizationQuery;
  const organization = data?.organization;
  const hotel = data?.hotel;

  const { isLoading, isError, errorMessage } = useQueryHelper({
    queries: [organizationQuery],
  });

  if (isLoading) {
    return <Spinner global />;
  }

  if (isError) {
    return (
      <PageWrapper>
        <ContentLoadError
          onRefreshClicked={() => {
            refetch();
          }}
          message={errorMessage}
        />
      </PageWrapper>
    );
  }

  const geo = hotel?.address?.geoPoint;
  const initialValues = organization ? {
    stars: hotel?.stars || 3,
    name: organization.name || organization.companyName || '',
    country: hotel?.address?.country || 'pl',
    city: hotel?.address?.city_name || organization.city || '',
    street: hotel?.address?.street || '',
    buildingNumber: hotel?.address?.number || '',
    apartmentNumber: hotel?.address?.apartmentNumber || '',
    postalCode: hotel?.address?.postal_code || '',
    latitude: organization.latitude?.toString() || geo?.latitude?.toString() || '',
    longitude: organization.longitude?.toString() || geo?.longitude?.toString() || '',
    email: organization.companyEmail || hotel?.email || '',
    phone: organization.companyPhone || hotel?.phone || '',
    phoneCountry: 'pl',
    currency: hotel?.currency || 'PLN',
    domain: organization.code || '',
    selectedLanguages: organization.languages || ['en', 'pl'],
    owner: organization.account_manager || '',
    plan: (organization.plan || 'BASIC') as 'BASIC' | 'STANDARD' | 'PRO' | 'TEST' | 'ULTIMATE' | 'CUSTOM',
    isTestMode: organization.isTestMode || false,
    testExpirationDate: organization.test_expiration_date
      ? new Date(organization.test_expiration_date)
      : null,
    aiTokenLimit: organization.aiTokenLimit || 10000000,
  } : undefined;

  return (
    <PageWrapper>
      <PageTitle title="Edit Organization" />
      <CreateOrganizationWizard
        initialValues={initialValues}
        isEdit
        organizationId={id}
      />
    </PageWrapper>
  );
};
